import CryptoJS from "crypto-js";

const getQueryParamPersonId = () => {
  const params = new URLSearchParams(window.location.search);
  const queryParamPersonId = params.get("personid"); // Impersonation
  let decryptedPersonId: string = "";

  if (queryParamPersonId) {
    const bytes = CryptoJS.AES.decrypt(
      decodeURIComponent(queryParamPersonId),
      CryptoJS.enc.Base64.parse(
        (window as any).currentEnvironment.REACT_APP_PERSON_ID_KEY
      ),
      {
        iv: CryptoJS.enc.Base64.parse(
          (window as any).currentEnvironment.REACT_APP_PERSON_ID_IV
        ),
      }
    );
    decryptedPersonId = bytes.toString(CryptoJS.enc.Utf8);
  }

  return decryptedPersonId ? parseInt(decryptedPersonId, 10) : null;
};

export default getQueryParamPersonId;
